import { useArenaSearch } from 'modules/jogador/home/useArenaSearch';
import { HeroSearchSection } from 'modules/jogador/home/components/HeroSearchSection';
import { SportFilterBar } from 'modules/jogador/home/components/SportFilterBar';
import { FeaturedArenasSection } from 'modules/jogador/home/components/FeaturedArenasSection';
import { HowItWorksSection } from 'modules/jogador/home/components/HowItWorksSection';
import { ArenaOwnerCtaSection } from 'modules/jogador/home/components/ArenaOwnerCtaSection';
import { Footer } from 'shared/components/layout/Footer';

export function MarketingHomePage() {
  const { searchTerm, setSearchTerm, sportId, setSportId, filteredArenas, isLoading, error } = useArenaSearch();

  return (
    <>
      {/* Chamada para donos de arena no topo: quem tem arena vê e cadastra sem rolar a página. */}
      <ArenaOwnerCtaSection />

      <HeroSearchSection
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        sportId={sportId}
        onSportChange={setSportId}
      />

      <div className="py-4">
        <SportFilterBar selectedSportId={sportId} onSelect={setSportId} />
      </div>

      <FeaturedArenasSection city="Fortaleza" arenas={filteredArenas} isLoading={isLoading} error={error} />

      <HowItWorksSection />
      <Footer />
    </>
  );
}
